
export function naturalLanguageJoin(input, and = '&', oxfordComma = false) {
	const list = input.slice()
	const last = list.pop()
	const conjunction = list.length > 1 && oxfordComma ? `, ${and} ` : ` ${and} `
	if (list.length) return list.join(', ') + conjunction + last
	return last
}